module.exports = __webpack_public_path__ + "static/spirehealth-98b8a52cd89e4eab0b2a31ad4a2188f8.png";